import { CircularProgress } from '@mui/material';

const LoadSpinner = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 40,
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default LoadSpinner;
